import { queryInventoryAuditorGlobalCatalog } from '@/hooks/useInventoryAuditorInventory';
import { queryTomVendingInventory } from '@/hooks/useTomVendingInventory';
import type { CatalogItemOption } from './CatalogItemAutocomplete';

const CATALOG_PAGE_SIZE = 20;

export async function searchTomVendingCatalogItems(search: string): Promise<CatalogItemOption[]> {
  const res = await queryTomVendingInventory({
    skip: 0,
    take: CATALOG_PAGE_SIZE,
    search,
    orderBy: 'upc',
    orderDirection: 'ASC',
  });
  return res.data.map((r) => ({ id: r.id, upc: r.upc, name: r.name }));
}

export async function searchInventoryAuditorCatalogItems(search: string): Promise<CatalogItemOption[]> {
  const res = await queryInventoryAuditorGlobalCatalog({
    skip: 0,
    take: CATALOG_PAGE_SIZE,
    search,
    orderBy: 'upc',
    orderDirection: 'ASC',
  });
  return res.data.map((r) => ({ id: r.id, upc: r.upc, name: r.name }));
}
